import { render, staticRenderFns } from "./TravelOrdersTable.vue?vue&type=template&id=5728955e"
import script from "./TravelOrdersTable.vue?vue&type=script&lang=js"
export * from "./TravelOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./TravelOrdersTable.vue?vue&type=style&index=0&id=5728955e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports